var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAboutUsIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1098_2719)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3636 6.85714C18.1745 6.85714 19.6255 5.32571 19.6255 3.42857C19.6255 1.53143 18.1745 0 16.3636 0C14.5527 0 13.0909 1.53143 13.0909 3.42857C13.0909 5.32571 14.5527 6.85714 16.3636 6.85714ZM7.63636 6.85714C9.44727 6.85714 10.8982 5.32571 10.8982 3.42857C10.8982 1.53143 9.44727 0 7.63636 0C5.82545 0 4.36364 1.53143 4.36364 3.42857C4.36364 5.32571 5.82545 6.85714 7.63636 6.85714ZM7.63636 9.14286C5.09455 9.14286 0 10.48 0 13.1429V16H15.2727V13.1429C15.2727 10.48 10.1782 9.14286 7.63636 9.14286ZM16.3636 9.14286C16.0473 9.14286 15.6873 9.16571 15.3055 9.2C16.5709 10.16 17.4545 11.4514 17.4545 13.1429V16H24V13.1429C24 10.48 18.9055 9.14286 16.3636 9.14286Z",
    fill: "current",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1098_2719"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 16,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUsIcon);
export default __webpack_public_path__ + "static/media/AboutUsIcon.fcb7f1df1993caec89680872c87a1dfa.svg";
export { ForwardRef as ReactComponent };